// extracted by css-extract-rspack-plugin
export default {"Box_1":"VisibleItems-module__Box_1__vn5F3"};